import PropTypes from 'prop-types';
import React from 'react';

import Button from '$partials/ui/button';
import Image from '$partials/media/image';
import IconArrowRight from '$partials/icons/arrow-right';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
const Large = 'Large';
const SMALL = 'Small';

const HeaderCardItem = ({
    cardTitle,
    cardSubtitle,
    index,
    media,
    ctaLink,
    ctaLabel,
    parent,
    size,
}) => {
    const { formatURI } = useLocale();

    return (
        <div
            className={`h-full ${size === 'Large' || parent === 'Landing' ? 'w-full' : 'w-full sm:w-1/2'} flex sm:px-5 md:px-10`}
            key={index}>
            <Button
                as='a'
                className={`block h-full w-full aspect-[375/300] ${size === Large ? 'sm:aspect-[2.35/1] w-full' : 'sm:aspect-[575/460]'} ${size === SMALL && !media ? 'h-full w-full' : ''} bg-black sm:rounded-button overflow-hidden`}
                href={formatURI(ctaLink)}>
                <div className='relative h-full'>
                    {media && (
                        <>
                            {media?.contentType?.includes('video/') ? (
                                <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    src={media?.src}
                                    width={'100%'} />
                            ) : (
                                <Image
                                    {...media}
                                    className='w-full h-full object-cover'
                                    containerClassName='w-full h-full relative'
                                    height='100%'
                                    loadWidth={1920}
                                    width='100%' />
                            )}
                        </>
                    )}
                    <div className='flex flex-col justify-between absolute bottom-0 left-0 px-20 md:px-60 py-35 md:py-[56px]'>
                        <div className='flex flex-col'>
                            {cardTitle && (
                                <p className={`type-style-2 text-white ${size === Large ? 'sm:w-1/2' : ''}`}>
                                    {cardTitle}
                                </p>
                            )}
                            {cardSubtitle && (
                                <p className={`pt-15 type-style-5 text-white w-10/12 ${size === Large ? 'sm:w-7/12' : ''}`}>
                                    {cardSubtitle}
                                </p>
                            )}
                            {ctaLabel && (
                                <p
                                    className='mt-15 md:mt-20 flex items-center text-white type-style-7'>
                                    {ctaLabel}
                                    <IconArrowRight className='h-13 ml-5' />
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </Button>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

HeaderCardItem.propTypes = {
    cardTitle: PropTypes.string,
    cardSubtitle: PropTypes.string,
    ctaLink: PropTypes.string,
    ctaLabel: PropTypes.string,
    index: PropTypes.number,
    media: PropTypes.object,
    parent: PropTypes.string,
    size: PropTypes.string,
};

export default HeaderCardItem;
